import PersonaPage from "./PersonaPage";
import { questionsPersonFemale } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für die Mama?",
    a: "Nicht mit Daten und Fakten — mit einem Bild. Ihre Hand auf Ihrer Stirn, wenn Sie Fieber hatten. Ihr Lachen am Telefon. Ein Satz, den nur sie so gesagt hat. Von dort aus schreibt sich die Rede fast von selbst.",
  },
  {
    q: "Darf eine Rede für Mama auch weniger formell sein?",
    a: "Ja — und sie sollte es. „Mama“ ist ein warmer, naher Name. Eine Rede, die sie so nennt, statt „unsere Mutter“, trifft den Ton, den viele Menschen im Raum als Erstes verstehen.",
  },
  {
    q: "Ich kann kaum daran denken, geschweige denn schreiben.",
    a: "Genau dafür ist der Fragebogen gemacht: acht kleine, ruhige Fragen, die Sie beantworten können — auch mit Tränen. Aus dem Rest machen wir einen Entwurf, den Sie dann verändern, kürzen, verwerfen können, wie es sich richtig anfühlt.",
  },
  {
    q: "Können wir ein Lied oder ein Foto einbinden?",
    a: "Sie können ein Lied oder einen Vers im Fragebogen hinterlegen — wir binden es behutsam in den Text ein. Fotos gehen direkt nicht ein, aber Sie können sie in der Trauerfeier neben die Rede stellen.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für den Papa", to: "/trauerrede-papa" },
  { label: "Trauerrede für die Mutter (formeller)", to: "/trauerrede-mutter" },
  { label: "Trauerrede für die Oma", to: "/trauerrede-oma" },
];

export default function TrauerredeMama() {
  return (
    <PersonaPage
      slug="trauerrede-mama"
      metaTitle="Trauerrede für Mama schreiben — warme Worte zum Abschied | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für Ihre Mama. Warm, nah, ohne Pathos. Aus acht behutsamen Fragen entsteht ein würdevoller Entwurf. Sofort verfügbar. Ab 29 €."
      eyebrow="Trauerrede · Mama"
      headline={
        <>
          Eine Trauerrede für Mama.
          <br />
          <span className="italic text-umber">Warm. Nah. In ihren Worten.</span>
        </>
      }
      intro={`„Mama“ ist mehr als ein Wort. Es ist ein Rückzugsort, ein Ton, ein Duft. Eine Trauerrede für sie darf genau so klingen — nicht wie ein Nachruf, sondern wie eine Erinnerung, die andere für einen Moment mit Ihnen teilen dürfen.`}
      heroImage="https://images.unsplash.com/photo-1490750967868-88aa4486c946?w=1920&q=80"
      heroImageAlt="Wiesenblumen auf einem hellen Küchentisch — Sinnbild einer Trauerrede für Mama"
      questions={questionsPersonFemale}
      exampleQuote={
        <>
          „Mama war nicht die Frau der großen Worte. Sie hat auch nicht Ratschläge in die Welt geworfen.
          Sie hat einfach die Küche warm gehalten, bis jeder wieder gehen konnte. Wer ihre Küche kannte,
          wusste, wie viel Liebe unauffällig sein darf. Wir wussten es. Und wir werden es weitergeben.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
